import React from 'react';

const StatCard = ({ label, value }) => (
  <div className="bg-white p-4 rounded shadow text-center">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-2xl font-semibold">{value ?? 0}</div>
  </div>
);

const OverallStatsBar = ({ stats = {} }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
      <StatCard label="Total Admins" value={stats.total_admins} />
      <StatCard label="Total Sub-Users" value={stats.total_subUsers} />
      <StatCard label="Total Bids" value={stats.total_bids} />
    </div>
  );
};

export default OverallStatsBar;